export const TravelInsuranceIcon = (props) => (
  <svg
    className={props.className}
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.09547 6.78833H15.0865C16.5911 6.78833 17.7995 7.99676 17.7995 9.50142C17.7995 10.9289 16.5613 12.1081 15.0865 12.1081H1.09547V6.78833ZM2.6914 8.38426V10.5122H15.0865C15.7395 10.5122 16.2036 9.98906 16.2036 9.50142C16.2036 8.87817 15.7097 8.38426 15.0865 8.38426H2.6914Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.84084 0.191895H9.96697L13.5461 8.27793H6.84084V0.191895ZM8.43677 1.78782V6.682H11.0944L8.92809 1.78782H8.43677Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.84084 10.5122H13.5461L9.96697 18.5982H6.84084V10.5122ZM8.43677 12.1081V17.0023H8.92809L11.0944 12.1081H8.43677Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.255814 5.80602L1.59021 5.09106L3.50533 6.89978L3.62137 7.92255L2.34462 9.83767L0.894184 9.52986L0.255814 5.80602Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.894184 9.2602L2.34462 8.95239L3.62137 10.8675L3.50533 11.8903L1.59021 13.699L0.255814 12.984L0.894184 9.2602Z"
      fill="#34363E"
    />
  </svg>
);
